import React, { createContext, useState, useContext } from 'react';
import '../pages/register/register.css'

const RegisterContext = createContext();

export const RegisterProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    store: '',
    Gender:'',
    dob:'',
    state:'',
    district:'',
    address:'',
    Category:[],
    companyPhotos:[],
    logo:'',
    person:'',
    description:'',
    field:''
  });

  return (
    <RegisterContext.Provider value={{ formData, setFormData }}>
      {children}
    </RegisterContext.Provider>
  );
};

export const useRegister = () => useContext(RegisterContext);
